import React, { useRef, useEffect, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Header from "../../components/common/Header";
import ContactFormSection from "./ContactFormSection";
import toast, { Toaster } from "react-hot-toast";

gsap.registerPlugin(ScrollTrigger);

const ContactHero = () => {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);

  // 1. Form State with all required fields
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    emailId: "",
    contactNo: "",
    enquiryType: "",
    country: "",
    state: "",
    city: "",
    message: "",
  });

  useEffect(() => {
    if (!sectionRef.current) return;

    const context = gsap.context(() => {
      if (titleRef.current) {
        gsap.fromTo(
          titleRef.current,
          { y: 50, opacity: 0, clipPath: "inset(100% 0 0% 0)" },
          {
            y: 0,
            opacity: 1,
            clipPath: "inset(0% 0 0% 0)",
            duration: 1.2,
            ease: "power2.out",
            scrollTrigger: {
              trigger: sectionRef.current,
              start: "top 90%",
              toggleActions: "play none none none",
            },
          },
        );
      }
    }, sectionRef);

    return () => context.revert();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // यह फंक्शन तब कॉल होगा जब EmailJS सफल हो जाएगा
  const handleSuccess = () => {
    toast.success("Message sent successfully!", {
      duration: 4000,
      position: "top-right",
      style: {
        background: "#343163",
        color: "#fff",
        borderRadius: "10px",
        border: "1px solid white",
      },
    });

    // फॉर्म रिसेट करें
    setFormData({
      firstName: "",
      lastName: "",
      emailId: "",
      contactNo: "",
      enquiryType: "",
      country: "",
      state: "",
      city: "",
      message: "",
    });
  };

  return (
    <div
      ref={sectionRef}
      className="relative w-full h-full"
      style={{
        backgroundImage: "url(/assets/contect/ContactBg.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Toaster />
      <div className="inset-0 flex flex-col justify-start items-center w-full h-full">
        <Header />
        <div className="w-full bg-cover bg-center pb-[23px] sm:pb-[34px] lg:pb-[46px] h-full flex flex-col justify-between items-center">
          <div className="flex justify-center mt-[30px] sm:mt-[100px] lg:mt-[135px]">
            <h1
              ref={titleRef}
              className="text-[40px] sm:text-[60px] md:text-[100px] lg:text-hero font-[Parkinsans] font-bold leading-[56px] sm:leading-[84px] md:leading-[112px] lg:leading-hero text-center text-[#343163]"
            >
              Contact Us
            </h1>
          </div>
          <div className="w-full max-w-[1620px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10 mt-[30px] sm:mt-[60px]">
            <ContactFormSection
              formData={formData}
              handleInputChange={handleInputChange}
              onSuccess={handleSuccess}
            />
          </div>
        </div>
      </div>
      <div className="w-full h-[160px] sm:h-[120px] lg:h-[146px] bg-[#0F1009]"></div>
    </div>
  );
};

export default ContactHero;
